<template lang="pug">
.d-flex.flex-column.full-height.align-end
  .relative.pointer-events-all
    v-overlay.filter-blur-1.rounded-16(
      v-if="loading"
      absolute
      color="redesignBackground"
      opacity="0.2"
      :z-index="10"
    )
      v-progress-circular(
        color="redesignPrimary"
        indeterminate
      )
    expand-menu(
      v-model="expandMenuControl"
      :type="MENU_TYPES.INDEPEND"
      offset-y
      left
      :close-on-click="true"
      :close-on-content-click="true"
      additional-menu-classes="rounded-12 redesign-box-shadow"
    )
      template(#activator="{ on, value }")
        app-button.ui-primary--text.no-before.rounded-10(
          color="white"
          v-on="on"
          dense
          height="36px"
        )
          p.ui-body-1 Все действия
          v-icon.ml-2(
            size="20"
            :class="{ 'rotate-180': value }"
            color="ui-primary"
          ) $ui-chevron-down
      v-list.d-flex.flex-column
        template(v-for="(button, idx) in activeActionsMenuButtons")
          expand-menu(
            v-if="button.submenu"
            :key="idx"
            :type="MENU_TYPES.INDEPEND"
            :offset-y="false"
            offset-x
            left
            additional-menu-classes="rounded-12 mt-0"
            nudge-top="8"
            nudge-left="8"
          )
            template(#activator="{ on }")
              v-list-item.body-1(
                :class="`${button.color}--text`"
                v-on="on"
              )
                v-icon(left size="24" :color="button.color") {{ button.icon }}
                | {{ button.text }}
            v-list(@click.native="closeMainMenuList")
              v-list-item.body-1(
                v-for="(submenuButton, submenuIdx) in button.submenu"
                :key="submenuIdx"
                :class="`${submenuButton.color}--text`"
                @click="submenuButton.action"
              )
                v-icon(left size="24" :color="submenuButton.color") {{ submenuButton.icon }}
                | {{ submenuButton.text }}
          app-tooltip(
            v-else
            :key="idx"
            :value="!!button.tooltip"
            left
          )
            template(#reason)
              p.redesignPrimaryDarken--text {{ button.tooltip }}
            v-list-item.body-1(
              :class="`${button.color}--text ${$vuetify.breakpoint.xs ? '' : 'text-nowrap'}`"
              :disabled="button.disabled"
              @click="button.action"
            )
              v-icon(left size="24" :color="button.color") {{ button.icon }}
              | {{ button.text }}

  portal(to="event-sections-editing-button")
    tooltip-wrap(
      v-if="event.status === EVENT_STATUS.DRAFT && !isEventManager"
      left
      content-class="redesign redesignControlsBackground redesign-box-shadow rounded-8 opacity-100"
    )
      template(#reason)
        p.redesignPrimaryDarken--text {{ isLocalEvent ? 'Опубликовать мероприятие' : 'Отправить мероприятие на модерацию' }}
      v-btn.rounded-12.pointer-events-all.redesignControlsBackground--text(
        dark
        small
        :height="40"
        :width="40"
        fab
        color="redesignSuccess"
        elevation="0"
        @click="actionsDialog(ACTION_TYPE.PUBLISH)"
      )
        v-icon(size="24") {{ isLocalEvent ? '$icheck-outline-circle' : '$iclock-outline' }}

  portal(to="event-actions-images-dialog.content" v-slot="{ close }")
    event-images(
      :event="event"
      :base-state="eventImagesDialogBaseState"
      :is-replacing-image="isReplacingExistsImage"
      @close="close"
    )

  portal(to="event-actions-overlay-dialog.content" v-slot="{ close }")
    event-overlay(
      :event="event"
      @close="close"
    )

  portal(to="moderate-publish-dialog.content" v-slot="{ close }")
    .d-flex.flex-column.gap-16.redesignBlack--text
      .title.weight-400
        | Организация, ответственная за модерацию указанного мероприятия,
        | в целях разделения задач между экспертами и уменьшения времени на выполнение предусмотренных процедур,
        | разделяет мероприятия между экспертами в зависимости от особенностей мероприятий.<br/>
        | Пожалуйста, выберите направление/особенность/принцп, наиболее верно характеризующий ваше мероприятие.
      v-select.moderate-action-select.title-1.weight-400(
        v-model="moderationTag"
        :items="moderationTags"
        item-text="text"
        item-value="value"
        placeholder="Выбор оператора"
        outlined
        append-icon="$ichevron-down"
        hide-details
        dense
      )
      .d-flex.gap-16.align-center.mt-4
        app-button.px-7.rounded-12.body-1.flex-1(
          outlined
          large
          :height="48"
          color="redesignPrimary"
          @click="close"
        ) Закрыть
        app-button.px-7.rounded-12.white--text.ma-0.body-1.flex-1(
          :loading="loading"
          large
          :height="48"
          color="redesignPrimary"
          @click="moderateEvent(close)"
        ) Сохранить
</template>

<script>
import EventImages, { STATE_CONTENT } from '@/modules/UserEventLanding/components/event-landing/main/dialogs/EventImages.vue';
import EventOverlay from '@/modules/UserEventLanding/components/event-landing/main/dialogs/EventOverlay.vue';
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import ExpandMenu, { MENU_TYPES } from '@/components/user-redesign/ExpandMenu.vue';
import { EVENT_STATUS, SECTION_STATUS, SECTION_TYPES } from '@/modules/UserEventLanding/constants';
import { DEFAULT_NOMINATION, EVENT_CLONE_DATA, EVENT_LEVELS } from '@/modules/Events/constants.js';
import AppCheckboxOld from '@/components/user-redesign/inputs/AppCheckboxOld.vue';
import AppLabelWrapper from '@/components/user-redesign/AppLabelWrapper.vue';

const ACTION_TYPE = {
  CLONE: 1,
  CLOSE: 2,
  PUBLISH: 3,
  REMOVE: 4,
};

const WITHOUT_MUN_PARAM = 0;

const NULL_MODERATON_TEXT = {
  REG: 'Отправить региональному оператору',
  MUN: 'Отправить муниципальному оператору',
};

const EVENT_CLONE_TEXT_ALERT_KEY = 'text-alert';

export default {
  name: 'EventActions',

  components: {
    EventImages,
    EventOverlay,
    AppButton,
    ExpandMenu,
  },

  props: {
    // event model
    event: { type: Object, required: true },
    sections: { type: Array, default: () => [] },
  },

  data() {
    return {
      MENU_TYPES,
      ACTION_TYPE,
      EVENT_STATUS,
      loading: false,
      expandMenuControl: false,

      eventImagesDialogBaseState: STATE_CONTENT.CROPPER,
      isReplacingExistsImage: false,

      moderationTag: null,
      moderationTags: [],
    };
  },

  computed: {
    isRouteEditor() {
      return !!this.$route.meta.editor;
    },
    isLocalEvent() {
      return this.event.level.id === EVENT_LEVELS.local;
    },
    isEventManager() {
      return this.$user?.isEventManager;
    },
    activeActionsMenuButtons() {
      return this.actionMenuButtons
        .filter((button) => !button.hidden)
        .map((button) => {
          const DEFAULT_COLOR = 'redesignMainBlack';
          const actualButton = { ...button };
          if (button.submenu) {
            actualButton.submenu = button.submenu
              .filter((submenuButton) => !submenuButton.hidden)
              .map((submenuButton) => ({
                ...submenuButton,
                color: submenuButton.color || DEFAULT_COLOR,
              }));
          }
          return {
            ...actualButton,
            color: button.color || DEFAULT_COLOR,
          };
        });
    },
    actionMenuButtons() {
      const { isEventManager, sections } = this;
      const requiredSections = sections
        .filter((section) => [SECTION_TYPES.ABOUT, SECTION_TYPES.UNITS].includes(section?.component?.type))
        .filter((section) => section.status.state === SECTION_STATUS.DRAFT);
      const isDisabledPublish = !!requiredSections.length;
      const disabledPublishTooltip = isDisabledPublish
        ? `Необходимо заполнить информацию в следующих секциях: ${requiredSections.map(({ title }) => title).join(', ')}`
        : null;
      return [
        {
          icon: '$ipencil',
          text: 'Редактировать обложку',
          submenu: this.actionImageSubmenuButtons,
        },
        {
          hidden: this.$conf.isVcht || isEventManager,
          icon: '$icopy',
          text: 'Клонировать мероприятие',
          action: () => this.cloneEventDialog(),
        },
        {
          hidden: this.event.status !== EVENT_STATUS.ACTIVE || isEventManager,
          icon: '$icheck-all',
          text: 'Завершить мероприятие',
          action: () => this.actionsDialog(ACTION_TYPE.CLOSE),
        },
        {
          hidden: this.event.status !== EVENT_STATUS.DRAFT || isEventManager,
          icon: this.isLocalEvent ? '$icheck-outline-circle' : '$iclock-outline',
          text: this.isLocalEvent ? 'Опубликовать мероприятие' : 'Отправить на модерацию',
          disabled: isDisabledPublish,
          color: isDisabledPublish ? 'redesignSecondary' : null,
          tooltip: disabledPublishTooltip,
          action: () => this.actionsDialog(ACTION_TYPE.PUBLISH),
        },
        {
          hidden: isEventManager,
          color: 'redesignError',
          icon: '$itrash',
          text: 'Удалить мероприятие',
          action: () => this.actionsDialog(ACTION_TYPE.REMOVE),
        },
      ];
    },
    actionImageSubmenuButtons() {
      return [
        {
          icon: '$iplus-outline',
          text: 'Добавить файл',
          action: () => this.imagesDialog(),
        },
        {
          hidden: this.event.images.length <= 1,
          icon: '$ipicture',
          text: 'Посмотреть все',
          action: () => this.imagesDialog(STATE_CONTENT.PREVIEW),
        },
        {
          hidden: this.event.images.length !== 1,
          icon: '$irefresh-outline',
          text: 'Заменить',
          action: () => this.replaceExistsImage(),
        },
        // {
        //   hidden: !this.event.main_image,
        //   icon: 'mdi-palette-outline',
        //   text: 'Наложение цвета',
        //   action: () => this.overlayDialog(),
        // },
        {
          hidden: this.event.images.length !== 1,
          color: 'redesignError',
          icon: '$itrash',
          text: 'Удалить',
          action: () => this.deleteExistsImage(),
        },
      ];
    },
    actionTypesData() {
      return {
        [ACTION_TYPE.CLONE]: {
          method: this.cloneEvent,
          message: 'Мероприятие будет клонировано',
          btnText: 'Подтвердить',
        },
        [ACTION_TYPE.CLOSE]: {
          method: this.closeEvent,
          message: `Мероприятие будет завершено.
            <div class="text-left title-1 weight-400">
              <p class="mt-7 mb-3">Завершая мероприятие, вы подтверждаете, что</p>
              <ul class="redesignError--text">
                <li class="my-2">все участники выполнили задания;</li>
                <li class="my-2">все задания были проверены экспертами;</li>
                <li class="my-2">все участники были награждены;</li>
                <li class="my-2">все этапы мероприятия завершены.</li>
              </ul>
            </div>
          `,
          btnText: 'Подтвердить',
        },
        [ACTION_TYPE.PUBLISH]: {
          method: this.publishEvent,
          message: 'Мероприятие будет опубликовано. После публикации, вы не сможете изменить некоторые данные.',
          btnText: 'Подтвердить',
        },
        [ACTION_TYPE.REMOVE]: {
          method: this.removeEvent,
          message: 'Вы действительно хотите удалить мероприятие?',
          btnText: 'Удалить',
        },
      };
    },
    cloneEventHiddenParams() {
      const { stages_count, nominations } = this.event;

      const nonDefaultNominations = nominations.filter(({ name }) => name !== DEFAULT_NOMINATION.NAME);

      return [
        ...nonDefaultNominations?.length ? ['has_nominations'] : [],
        ...stages_count ? ['is_without_stages'] : [],
      ];
    },
  },
  created() {},
  methods: {
    actionsDialog(action) {
      if (action === ACTION_TYPE.PUBLISH && !this.isLocalEvent) {
        this.moderatePublishDialog();
        return;
      }
      const currentData = this.actionTypesData[action];
      this.$dialogs.confirm({
        attrs: {
          method: currentData.method,
          message: currentData.message,
          closeBtnAttrs: {
            'btn-text': 'Закрыть',
          },
          confirmBtnAttrs: {
            'btn-text': currentData.btnText,
          },
        },
      });
    },

    async moderatePublishDialog() {
      const params = {
        'search[region_id]': this.$user.data.organizer.region.id,
        'search[municipality_id]': WITHOUT_MUN_PARAM,
      };
      const regionTags = (await this.$rApi.moderation.showTags({ params })).response.data.data;
      if (this.event.level.id === EVENT_LEVELS.municipal) {
        params['search[municipality_id]'] = this.$user.data.organizer.municipality.id;
        const regionAndMunTags = (await this.$rApi.moderation.showTags({ params })).response.data.data;
        const munTags = regionAndMunTags.filter((tag) => !regionTags.find((t) => t.id === tag.id));
        this.moderationTags = munTags.map((tag) => ({ value: tag.id, text: tag.name }));
        this.moderationTags.unshift({ value: null, text: NULL_MODERATON_TEXT.MUN });
      } else {
        this.moderationTags = regionTags.map((tag) => ({ value: tag.id, text: tag.name }));
        this.moderationTags.unshift({ value: null, text: NULL_MODERATON_TEXT.REG });
      }

      this.$dialogs.portal({
        attrs: {
          'max-width': 600,
          hideActions: true,
          title: 'Подтвердите действие',
          inputValue: 'moderate-publish-dialog',
          containerAttrs: {
            class: 'pa-8',
          },
        },
      });
    },

    cloneEventDialog() {
      const { response } = this.event?.options || {};

      const eventCloneData = EVENT_CLONE_DATA
        .filter(({ value }) => !this.cloneEventHiddenParams.includes(value))
        .filter((item) => response[item.value] !== item.default);

      if (!eventCloneData.length) {
        this.actionsDialog(ACTION_TYPE.CLONE);
      } else {
        const convertedCloneData = eventCloneData.map(({ value, text }) => ({ value, text: text(response) }));

        const baseCheckbox = {
          component: AppCheckboxOld,
          component_attrs: {
            class: 'body-2 text-left mt-0 mb-2',
            'hide-details': true,
          },
        };
        const fields = [
          {
            value: EVENT_CLONE_TEXT_ALERT_KEY,
            component: AppLabelWrapper,
            text: `Вы можете упростить себе задачу по созданию нового мероприятия, создав копию выбранного сейчас мероприятия.
              Выберите ниже, какие настройки мероприятия должны быть обязательно перенесены в новое мероприятие`,
            component_attrs: {
              class: 'body-1 text-left mt-n4 mb-4',
            },
          },
          ...convertedCloneData.map((data) => ({
            ...data,
            ...baseCheckbox,
          })),
        ];
        const formValue = Object.fromEntries(convertedCloneData.map(({ value }) => ([value, true])));
        this.$dialogs.form({
          attrs: {
            'max-width': 650,
            title: 'Параметры клонирования',
            method: ({ data }) => this.cloneEvent(data),
            serializeFormData: this.cloneEventOptionsParams,
            formValue,
            initial: formValue,
            fields,
            closeBtnAttrs: {
              'btn-text': 'Отмена',
              height: 40,
              class: 'body-1 rounded-12 px-5',
            },
            confirmBtnAttrs: {
              'btn-text': 'Клонировать',
              height: 40,
              class: 'body-1 rounded-12 px-5',
            },
          },
        });
      }
    },

    cloneEventOptionsParams(form) {
      const { response } = this.event?.options || {};
      return Object.fromEntries(EVENT_CLONE_DATA.filter(({ value }) => !this.cloneEventHiddenParams.includes(value)).map((item) => {
        const value = form[item.value] ? response[item.value] : (item.serverDefault || item.default);
        return [item.value, value];
      }));
    },

    // IMAGE MANAGEMENT
    imagesDialog(state = STATE_CONTENT.CROPPER) {
      this.eventImagesDialogBaseState = state;
      this.$dialogs.portal({
        attrs: {
          'max-width': 1000,
          hideActions: true,
          persistent: true,
          title: 'Редактирование обложки',
          inputValue: 'event-actions-images-dialog',
          containerAttrs: {
            class: 'pa-8',
          },
        },
        listeners: {
          'before:close': () => {
            this.isReplacingExistsImage = false;
          },
        },
      });
    },
    replaceExistsImage() {
      this.isReplacingExistsImage = true;
      this.imagesDialog();
    },
    deleteExistsImage() {
      if (this.event.images.length > 1) return;
      this.$dialogs.confirm({
        attrs: {
          method: () => this.deleteImage(),
          message: 'Вы действительно хотите удалить изображение?',
          closeBtnAttrs: {
            'btn-text': 'Оставить',
          },
          confirmBtnAttrs: {
            'btn-text': 'Удалить',
          },
        },
      });
    },
    async deleteImage() {
      const [image] = this.event.images;
      if (!image?.id) return false;
      const response = this.event.deleteImage(image.id);
      this.$toast.success('Обложка удалена');
      return response;
    },
    closeMainMenuList() {
      this.$nextTick(() => {
        this.expandMenuControl = false;
      });
    },

    // OVERLAY MANAGEMENT
    overlayDialog() {
      this.$dialogs.portal({
        attrs: {
          'max-width': 700,
          hideActions: true,
          persistent: true,
          title: 'Редактирование верхнего слоя',
          inputValue: 'event-actions-overlay-dialog',
          containerAttrs: {
            class: 'pa-8',
          },
        },
      });
    },

    // EVENT MANAGEMENT
    async cloneEvent(savedOptions = null) {
      this.loading = true;
      const payload = {
        args: [this.event.id],
      };

      const { response, error } = await this.$rApi.events.cloneEvent(payload);
      if (!error) {
        const { id, options_id } = response?.data?.data || {};
        if (savedOptions && options_id) {
          await this.$rApi.events.updateEventOptions({ args: [options_id, savedOptions] });
        }
        if (id) {
          this.$router.push({ name: 'event-dashboard-main', params: { id } });
        }
        this.$toast.success('Мероприятие успешно клонировано');
      }
      this.loading = false;
      return response;
    },
    async closeEvent() {
      this.loading = true;
      const unassignedPrizePlaces = await this.event.getUnassignedPrizePlaces();
      if (unassignedPrizePlaces.length) {
        this.$toast.error('Необходимо распределить призовые места');
        this.loading = false;
        return;
      }

      const response = await this.$rApi.events.closeEvent({ args: [this.event.id] });
      if (!response.error) {
        this.$toast.success('Мероприятие завершено', { timeout: 2000 });
        this.event.status = EVENT_STATUS.CLOSED;
      }
      this.loading = false;
    },
    async moderateEvent(functionClose) {
      await this.publishEvent();
      if (this.moderationTag) {
        await this.$rApi.moderation.attachEventsToTag({ args: [this.moderationTag, { ids: [this.event.id] }] });
      }
      if (functionClose && typeof functionClose === 'function') functionClose();
    },
    async publishEvent() {
      this.loading = true;
      const params = {
        status: this.isLocalEvent ? EVENT_STATUS.ACTIVE : EVENT_STATUS.MODERATE,
      };
      const response = await this.$rApi.events.publishEvent({ args: [this.event.id, params] });
      if (!response.error) {
        this.$toast.success(this.isLocalEvent ? 'Мероприятие опубликовано' : 'Мероприятие отправлено на модерацию', { timeout: 2000 });
        this.event.status = params.status;
      }
      this.loading = false;
      return response;
    },
    async removeEvent() {
      this.loading = true;
      const response = await this.$rApi.events.deleteEvent({ args: [this.event.id] });
      this.loading = false;
      this.$router.push(this.$user.isAdmin ? '/event-templates' : '/organization-events/my');
      return response;
    },
  },
};
</script>
<style scoped lang="scss">
.moderate-action-select {
  &::v-deep .v-select__selection--comma {
    min-height: 20px !important;
  }

  &::v-deep .v-icon__component {
    height: unset;
    width: 16px;
  }
}
</style>
